module.exports = __webpack_public_path__ + "img/hand-logotipo-grey.670e0d7c.svg";